import { enumRecordToCheckboxOptions } from '@umss/shared/utils';

export enum FacilityClassification {
  STANDARD = 'Standard',
  INTERMEDIATE = 'Intermediate',
  EXPERT = 'Expert',
  OTHER = 'Other'
}

export const FACILITY_CLASSIFICATION_LIST = enumRecordToCheckboxOptions(
  FacilityClassification
);
